import axios from './axiosInstance';


const setDefaults=() => {
    axios.defaults.headers.common['Content-Type']='application/x-www-form-urlencode';
    axios.defaults.headers.common['Accept']='application/json';
};

const AddOption=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/add`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const ChangeOptionsVisibility=({token,data}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/changeVisibility`,data)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const DeleteOption=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.delete(`/options/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}
const DeleteOptions=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/bulkDelete`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetOption=({token,_id,venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/${_id}`,{venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const GetOptions=({token, venue}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/`,{venue})
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteOption=({token,_id}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/options/undelete/${_id}`,)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

const UnDeleteOptions=({token,_ids}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.patch(`/options/undelete/bulk`,_ids)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}


const UpdateOption=({token,option}) => {
    setDefaults()
    return new Promise((resolve,reject) => {
        axios.defaults.headers.common={'auth-token': `${token}`}
        axios.post(`/options/update/${option._id}`,option)
            .then(response => resolve(response.data))
            .catch((error) => {reject(error.response)})
    })
}

export {
    AddOption,
    ChangeOptionsVisibility,
    DeleteOption,
    DeleteOptions,
    GetOption,
    GetOptions,
    UnDeleteOption,
    UnDeleteOptions,
    UpdateOption,
}



